import {
  FormField,
  Input,
} from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

function PLCTextInput({
  label,
  description = '',
  disabled = false,
  value = '',
  onUpdate,
}) {
  const [currentValue, setCurrentValue] = useState(value ?? '');

  useEffect(() => {
    setCurrentValue(value ?? '');
  }, [value]);

  const savedValue = value ?? '';
  const hasUnsavedChanges = currentValue !== savedValue;

  const handleBlur = () => {
    if (!hasUnsavedChanges) {
      return;
    }

    onUpdate(currentValue);
  };

  return (
    <FormField
      label={label}
      description={description}
      errorText={hasUnsavedChanges ? 'Unsaved changes (click away to save).' : null}
      stretch
    >
      <Input
        value={currentValue}
        disabled={disabled}
        onChange={({ detail }) => { setCurrentValue(detail.value); }}
        onBlur={handleBlur}
      />
    </FormField>
  );
}

PLCTextInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  value: PropTypes.string,
  onUpdate: PropTypes.func.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disabled: PropTypes.bool,
};

export default PLCTextInput;
